import { Grid } from '@material-ui/core';
import React from 'react';
import FormAlongsideText from '../../../../yoello-lib/modules/dynamicForms/FormComponents/FormAlongsideText';
import ICommonFormProps from '../interfaces/ICommonFormProps';
import { FormPricingField } from './FormPricingField';

interface FormPriceFieldTextAlongsideProps extends ICommonFormProps {
    displaySymbol?: boolean;
}

export function FormPriceFieldTextAlongside(props: FormPriceFieldTextAlongsideProps) {
    return (
        <Grid container justify="center" alignItems="center" spacing={1} className={props.className}>
            <Grid item xs={props.formProps?.secondLabel ? 4 : 6}>
                <FormPricingField {...props} />
            </Grid>
            <Grid item xs={props.formProps?.secondLabel ? 8 : 6}>
                <FormAlongsideText
                    label={props.formProps?.sideLabel || props.label}
                    secondLabel={props.formProps?.secondLabel}
                />
            </Grid>
        </Grid>
    );
}
